import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Immutable from 'immutable';

import { BrandLogo } from '../../brand_logo/brand_logo';
import { Price } from '../../quote_price/price/price';
import { SimpleFlexbox } from '../../flexbox/flexbox';
import { CloseIcon } from '../../close_icon/close_icon';

import styles from './product.css';

class Product extends Component {

    constructor(...args) {
        super(...args);
        this.animatedSpeed = 300;
        this.state = {
            entering: true,
            leaving: false
        };
    }

    componentDidMount = () => {
        setTimeout(() => {
            this.setState({ entering: false });
        }, this.animatedSpeed);
    };

    componentWillReceiveProps = () => {
        this.setState({ leaving: false });
    };

    handleCloseClick = () => {
        const { product, removeProduct } = this.props;
        const productId = product.getIn(['productMeta', 'id']);
        this.setState({ leaving: true }, () => {
            setTimeout(() => {
                removeProduct(productId);
            }, this.animatedSpeed);
        });
    };

    render = () => {
        const { entering, leaving } = this.state;
        const { product, logoSrcPath, frequency } = this.props;
        const frequencyStateKey =  frequency === 'annual' ? 'annualPremium' : 'monthlyPremium';
        const price =  product.getIn(['productMeta', 'price', frequencyStateKey]);

        return (
            <SimpleFlexbox
                className={classNames({ [styles.fade_in]: entering, [styles.bounce_out]: leaving })}
                display="flex"
                flex={1}
                contentCenter="xs"
                margin="all_xsmall"
                position="relative"
            >
                <div className={styles.container}>
                    <div className={styles.logo_price}>
                        <BrandLogo
                            stateProps={{ product }}
                            elementProps={{ srcPath: logoSrcPath }}
                            visualProps={{ variant: 'compare_product_logo' }}
                        />
                        <span className={styles.price || 'N/A'}>
                            <Price price={price} frequency={frequency} origin={'product'} />
                        </span>
                    </div>
                    <div className={styles.name}>
                        {product.getIn(['productMeta', 'name'])}
                    </div>
                </div>
                <CloseIcon handleClick={this.handleCloseClick} />
            </SimpleFlexbox>
        );
    };

}
Product.propTypes = {
    logoSrcPath: PropTypes.string.isRequired,
    product: PropTypes.instanceOf(Immutable.Map),
    removeProduct: PropTypes.func.isRequired,
    frequency: PropTypes.string.isRequired
};
export { Product };
